import React from 'react';

import ProjectPlaceholder from 'components/placeholders/project.placeholder';
import TasksViewPlaceholder from 'components/placeholders/tasks-view.placeholder';

const Placeholder = () => (
    <ProjectPlaceholder bodyClassName="project-generic-holder project-generic-holder-tasks">
        <div className="filter-box-holder">
            <div className="filter-box" />
        </div>

        <TasksViewPlaceholder />
    </ProjectPlaceholder>
);

export default Placeholder;
